import { Inject, Injectable } from "@angular/core";
import { Actions } from "@ngrx/effects";
import { ScannedActionsSubject } from "@ngrx/store";
import { from, Observable, of } from "rxjs";
import { mergeMap } from "rxjs/operators";

import { ActionWithPayload } from "../model";

import { BATCH_ACTION_TYPE } from "./actions-batcher";

@Injectable()
export class ActionsExtended extends Actions {
	constructor(@Inject(ScannedActionsSubject) actionsSubject: Observable<ActionWithPayload>) {
		super(
			actionsSubject.pipe(
				mergeMap((action: ActionWithPayload) => {
					if (action.type === BATCH_ACTION_TYPE.batchActions) {
						return from([action, ...action.payload]);
					}
					return of(action);
				})
			)
		);
	}
}
